import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getAccessManagementCounts = async (token, municipalityId) => {
  const url = `municipalities/${municipalityId}/sod_counts`
  const data = await apiGet({ url, token })
  return data
}

export function useAccessManagementCounts({ options }) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const queryFn = () => getAccessManagementCounts(token, municipality_id)
  const queryKey = 'sod_counts'
  return useQuery(queryKey, queryFn, { ...options })
}
